._1il9u30 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}